
export const FirebaseConfig = {
    apiKey: "AIzaSyCtVnh04QgjBntuI5_sAU4IvmBYLJ0Nz-M",
    authDomain: "jess-apps-4420.firebaseapp.com",
    projectId: "jess-apps-4420",
    storageBucket: "jess-apps-4420.firebasestorage.app",
    messagingSenderId: "954242843055",
    appId: "1:954242843055:web:8221131596eea0f3a16f5a"
};